import { WithJustificationChangeModal } from '@schooly/components/justifications';
import React, { FC } from 'react';

import { ModalLarge } from '../../../components/uikit-components/Modal/Modal.styled';
import { useRouter } from '../../../context/router/useRouter';
import { AttendanceJustificationsContent } from './AttendanceJustificationsContent';

export const AttendanceJustificationsModal: FC = () => {
  const { closeAndClean: closeModal } = useRouter();

  return (
    <WithJustificationChangeModal>
      <ModalLarge open onClose={closeModal}>
        <AttendanceJustificationsContent onClose={closeModal} />
      </ModalLarge>
    </WithJustificationChangeModal>
  );
};
